var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "-5 -5 210 210" },
    },
    [
      _c("g", { attrs: { id: "Inverter" } }, [
        _c("rect", {
          staticClass: "cls-1-inv stroke",
          attrs: { width: "188", height: "188", x: "5", y: "5", rx: "15" },
        }),
        _c("line", {
          staticClass: "stroke",
          attrs: { x1: "10", x2: "190", y1: "190", y2: "10" },
        }),
        _c("line", {
          staticClass: "stroke stroke-bold",
          attrs: { x1: "88", x2: "168", y1: "140", y2: "140" },
        }),
        _c("line", {
          staticClass: "stroke stroke-bold",
          attrs: { x1: "88", x2: "168", y1: "168", y2: "168" },
        }),
        _c("path", {
          staticClass: "wave",
          attrs: {
            d: "M 10,30 Q 25,60 40,30 t 30,0 30,0",
            transform: "translate(12 12)",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }